export default __webpack_public_path__ + "static/45-fast-growth-b2b-saas-united-kingdom-269ac2f1f156861d40f87ae08c97166f.png";